<ngx-editor-menu [class.disabled]="disabled()" [editor]="editor" [disabled]="disabled()" [toolbar]="toolbar">
</ngx-editor-menu>
<ngx-editor
  [class.disabled]="disabled()"
  [class.error]="error()"
  [placeholder]="placeholder()"
  [disabled]="disabled()"
  [editor]="editor"
  [ngModel]="value()"
  (ngModelChange)="handleInput($event)">
</ngx-editor>
